export default __webpack_public_path__ + "static/media/ic_inj_24.617fa372.svg";